<template>
  <div>
<!--    <header class="terms-header">-->
<!--      <h2 v-html="termsTitle"></h2>-->
<!--    </header>-->
    <div class="terms-content" v-html="termsContent"></div>
  </div>
</template>

<script>
export default {
  name: "SafeGaurdTermsSKT",
  data: () => ({
    termsTitle: "",
    termsContent: "",
    accType: "",
    termType: ""
  }),
  computed: {
    termCd() {
      let code;
      if (this.accType === 'join') {
        switch (this.termType) {
          case "service":
            code = "101";
            break;
          case "privacy":
            code = "102";
            break;
          case "third-party":
            code = "103";
            break;
          case "alarm":
            code = "104";
            break;
          case "skt-third-party":
            code = "105";
            break;
        }
      } else {
        switch (this.termType) {
          case "service":
            code = "002";
            break;
          case "privacy":
            code = "003";
            break;
        }
      }
      return code;
    }
  },
  methods: {
    getTerms(termsCd) {
      this.axios.post("/view/getTerms", {termsCd, prdtNo: "A001", teleCoCd: '1'}).then(res => {
        if (res.data.resultCode === "S0000") {
          //약관 다운로드 버튼 제어하도록 추가
          this.termsTitle = res.data.termsTitle;
          this.termsContent = res.data.termsContent;
        } else {
          this.termsTitle = "";
          this.termsContent = res.data.resultMsg;
        }
      });
    }
  },
  created() {
    this.accType = this.$route.path.includes("join") ? "join" : "";
    this.termType = this.$route.params.termType;
    this.getTerms(this.termCd);
  }
}
</script>

<style scoped lang="scss">
.terms-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  text-align: center;
  padding: 18px;
  line-height: 1;
  box-shadow: 0 0 2px 1px rgba(0,0,0,0.2);

  h2 {
    font-size: 16px;
    color: #222;
  }
}

.terms-content {
  padding: 20px;
  color: #222;
}
</style>